import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from "vuex";
import BootstrapVue from 'bootstrap-vue';
import VueI18n from "vue-i18n";
import VueI18nFilter from "vue-i18n-filter";
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import './custom.scss';
import App from './App.vue';
import routerConfig from "@/router/router-config";
import storeConfig from '@/store/store-config';
import actions from "@/store/actions";
import i18nConfig from "@/lang/lang";
import Vuelidate from "vuelidate";
import {
    capitalizeFilter,
    displayChoice,
    formatDate, nullableNumber,
    nullableString,
    yesNoFilter,
    yesNoNullFilter
} from "@/utils/formatting";
import {daysFrom, logRequestError} from "@/utils/utils";
import IdleVue from 'idle-vue';
import vueIdleConfig from '@/vue-idle/vue-idle-config';
import HemocirButton from "@/components/HemocirButton";
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueI18n);
Vue.use(VueI18nFilter);
Vue.use(Vuelidate);

const store = new Vuex.Store(storeConfig);
const router = new VueRouter(routerConfig);
const i18n = new VueI18n(i18nConfig);

Vue.filter('capitalize', capitalizeFilter);
Vue.filter('choice', displayChoice);
Vue.filter('date', (date, props={}) => formatDate(date, props));
Vue.filter('time',  date => formatDate(date, {format: 'time'}));
Vue.filter('datetime',  (date, props) => formatDate(date, {format: 'datetime', ...props}));
Vue.filter('daysFrom', daysFrom);
Vue.filter('yesno', yesno => i18n.t(yesNoFilter(yesno)));
Vue.filter('yesnonull', yesno => yesNoNullFilter(yesno, i18n));
Vue.filter('valueOrEmpty', nullableString);
Vue.filter('numberOrEmpty', nullableNumber);


Vue.use(IdleVue, {
    ...vueIdleConfig,
    store
});


Sentry.init({
    dsn: process.env.VUE_APP_SENTRYURL,
    integrations: [new VueIntegration({Vue, attachProps: true})],
    environment: "dev",
    beforeSendRequest(event) {
        console.error(event);
        return event;
    }
});

router.beforeEach((to, from, next) => {
    actions.getCurrentUser(store)
        .then(currentUser => {
            if (currentUser.force_password_reset) {
                if (to.name === 'password-change') {
                    next();
                } else {
                    next({name: 'password-change'});
                }
            } else {
                next();
            }
        })
        .catch(error => {
            if (error.response !== undefined && error.response.status === 403) {
                location.replace(process.env.VUE_APP_SERVERURL + 'api-auth/login/?next=' + to.path);
            } else {
                logRequestError(error);
                next();
            }
        });
});

Vue.component('hemocir-button', HemocirButton);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
